function ReadMore({ ...props }) {

  const toggleReadMore = () => {
    props.setIsExpanded(!props.isExpanded);
    props.setIsReadMore(!props.isReadMore);
  };
  return (
    <div
      id="expandbtn"
      onClick={toggleReadMore}
      className="services-read-more-text"
    >
      {/* <i className="fa fa-arrow-up"></i> */}
      <i className={props.isExpanded ? "fa fa-arrow-up" : "fa fa-arrow-down"}></i>
      {props.isExpanded ? " Read Less" : " Read More..."}
    </div>
  );
}

export default ReadMore;
